import Tags from './tags'
import Uploads from './uploads'
import Accounts from './accounts'
import { BadDataReviewSubmissions } from './review-bad-data/BadDataReviewSubmissions'
import { AuthorizersPage } from './authorizers'

export default {
  Tags,
  Uploads,
  Accounts,
  ReviewBadData: BadDataReviewSubmissions,
  Authorizers: AuthorizersPage,
}
